'use strict'

import { PMService } from '../services'
const getDefaultState = () => {
  return {
      currentInqVendor: undefined,
      newVendorEntry: undefined,
      receiptTransaction: undefined,
      receiptInqTransaction: undefined,
      postingReceiptTransaction: false
  }
}

// initial state
const state = getDefaultState()

const actions = {
  resetState ({ commit }) {
    commit('resetState')
  },
  setInquiryVendor({ commit },vendor ) {
      return new Promise((res, rej)  => {
          commit("SET_VENDOR_INQ", vendor);
          res(true);
      })
  },
  // Product new entry
  setNewVendorCode({commit}, vendor_code){
      return new Promise((res, rej) => {
          commit("SET_NEW_VENDOR",vendor_code);
          res(true);
      })
  },
  insertReceiptTranItem({ state, commit }, { productCode, quantity, unitCost}) {
    let { receiptNumber } = state.receiptTransaction ? state.receiptTransaction : state.receiptInqTransaction
     
    if (!receiptNumber) return;      

    return PMService.postProduct({ receiptNumber, productCode, quantity, unitCost })
      .then(({ status, data }) => {
        if (status == 201) {
          return data
        }
      })
  },
  setNewReceiptTransaction({ commit }) {
    return PMService.bookNewReceiptTransaction()
      .then(({ status, data }) => {
        if (status == 201) {
          commit("SET_NEW_RECEIPT_TRANSACTION",{ receiptNumber: data.receipt_number});
          return data;
        }
      })
  },
  setInqReceiptTransaction({commit}, inquiry){
    return new Promise((res, rej) => {
        commit("SET_INQ_RECEIPT_TRANSACTION",inquiry);
        res(true);
    })      
  },
  deleteReceiptTransaction({ state, commit }) {
    let {receiptNumber } = state.receiptTransaction ? state.receiptTransaction : state.receiptInqTransaction
     
    if (!receiptNumber) return;
    
    return PMService.deleteBookReceiptTransaction(receiptNumber)
      .then(({ status, data }) => {
        if (status == 200) {
          commit("SET_NEW_RECEIPT_TRANSACTION")
        }
        return { status, data };
      })
  },
  saveOpenMasterTrans({ state, commit }, {vendorCode, documentNumber, receiptDate, currencyCode }) {    
    let { receiptNumber } = state.receiptTransaction ? state.receiptTransaction : state.receiptInqTransaction
     
    if (!receiptNumber ) return;

    return PMService.saveOpenMasterTrans({ receiptNumber,documentNumber, vendorCode, receiptDate, currencyCode })
      .then(({ status, data }) => {
        if (status === 200) {
          commit("SET_NEW_RECEIPT_TRANSACTION")
          commit("SET_INQ_RECEIPT_TRANSACTION")
          return data
        }
      })
  },
  postReceiptTrans({commit, dispatch}, data) {
    commit("SET_RCPT_POSTING_STATUS", true )
    dispatch('saveOpenMasterTrans',data).then(data => {
      return data.receipt_number;
    })
    .then(receipt_number => {
      PMService.postReceiptTransaction(receipt_number)
        .then(response => { return response })
    })
    .finally(() => {
      commit("SET_RCPT_POSTING_STATUS", false )
    })
  }
}

const mutations = {
  resetState (state) {     
    Object.assign(state, getDefaultState())
  },
  SET_VENDOR_INQ(state, vendor) {
      state.currentInqVendor = vendor;
      state.newVendorEntry = null;
  },
  SET_NEW_VENDOR(state, vendor_code) {
      state.newVendorEntry = vendor_code;
      state.currentInqVendor = null;
  },
  SET_NEW_RECEIPT_TRANSACTION(state, payload) {
    state.receiptTransaction = payload;
  },
  SET_INQ_RECEIPT_TRANSACTION(state, payload) {
    state.receiptInqTransaction = payload;
  },
  SET_RCPT_POSTING_STATUS(state, payload) {
    state.postingReceiptTransaction = payload
  }
}

const getters = {
  isVendorInquiry: state => {
      return state.currentInqVendor === null ? false : true;
  },
  isNewVendor: state => {
      return state.newVendorEntry === null ? false : true;
  },
  newVendorEntry: state => {
    return state.newVendorEntry;
  },
  newTransaction: state => {
    return state.receiptTransaction;
  },
  isInquiryTransaction: state => {
    return state.receiptInqTransaction
  }
}

export const purchase = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/pm.module.js